import { useState } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { useResetPassword } from '@/features/auth/hooks/useResetPassword';
import { useNavigate } from 'react-router-dom';

export const ForgetPasswordPage = () => {
    const { resetPassword, loading, error } = useResetPassword();
    const [email, setEmail] = useState('');
    const [touched, setTouched] = useState(false);
    const [success, setSuccess] = useState(false);

    const isInvalid = touched && (!email || !!error);


    const navigate = useNavigate();
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setTouched(true);
        if (!email) return;

        const ok = await resetPassword(email);
        setSuccess(ok);
        if (ok) {
            navigate(`/check-email?email=${email}`);
        }
    };

    return (
        <main className="layout__content">
            <section className="section layout__section auth">
                <div className="container">
                    <div className="auth__block auth-block">
                        <header className="auth-block__header">
                            <h1 className="title auth-block__title">Забыли пароль?</h1>
                        </header>
                        <div className="auth-block__content">
                            <form className="form auth__form auth-form" onSubmit={handleSubmit} noValidate>
                                <fieldset className="auth-form__hint" style={{ marginBottom: 20 }}>
                                    <span className="auth-form__hint-text">
                                        Укажите email, под которым вы зарегистрированы. Мы отправим ссылку на восстановление.
                                    </span>
                                </fieldset>

                                {error && (
                                    <div style={{ color: '#EA3323', marginBottom: '1rem', fontWeight: 500 }}>
                                        На сайте не найдено пользователя с таким email.
                                    </div>
                                )}


                                <fieldset className="auth-form__fields">
                                    <div className="form__row">
                                        <div className="input">
                                            <label htmlFor="email" className="input__label input-label">E-Mail</label>
                                            <label className={clsx("text-input", {
                                                'text-input--error': isInvalid
                                            })}>
                                                <input
                                                    id="email"
                                                    className="text-input__input"
                                                    placeholder={isInvalid ? 'Введите ваш email' : 'example@gmail.com'}
                                                    type="email"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    onBlur={() => setTouched(true)}
                                                    required
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="auth-form__submit">
                                    <button
                                        className="button button_outline button_block auth-form__submit-button"
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? 'Отправка...' : 'Отправить'}
                                    </button>
                                </fieldset>

                                <fieldset className="auth-form__hint">
                                    <span className="auth-form__hint-text">Вспомнили пароль?</span>{' '}
                                    <Link className="form__link" to="/login">Войти</Link>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};
